import { CHANGELOG_LIST_PAGE_SIZE } from '../../../shared/constants/articleListPagination';
import { buildPaginatedArticleListUrl } from '../../../shared/lib/buildPaginatedArticleListUrl';
import { LANDING_FEATURE_COUNT } from './landingFeatures';

export const LIST_PREFETCH_PATHS = [
  `/api/articles?type=feature&limit=${LANDING_FEATURE_COUNT}`,
  '/api/articles?type=article&limit=4',
  '/api/articles?type=feature&limit=10',
  '/api/articles?type=article&limit=30',
  '/api/articles?type=integration&limit=30',
  '/api/articles?type=changelog&limit=10',
  '/api/articles?type=docs',
  '/api/articles?type=feature',
  '/api/articles?type=article',
  '/api/articles?type=integration',
  buildPaginatedArticleListUrl({
    type: 'changelog',
    pageSize: CHANGELOG_LIST_PAGE_SIZE,
    offset: 0,
  }),
] as const;

export const ARTICLE_PREFETCH_PATHS = [
  '/api/articles/power',
  '/api/articles/saga',
] as const;
